import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import ProjectValidation from './ProjectValidation';
import Projects from './Projects';
import './AdminComponents.css';

const ProjectsTab = () => {
    const [activeSubTab, setActiveSubTab] = useState(0);

    const handleSubTabChange = (event, newValue) => {
        setActiveSubTab(newValue);
    };

    return (
        <div className="projects-tab-container">
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs 
                    value={activeSubTab} 
                    onChange={handleSubTabChange}
                    aria-label="sous-onglets projets"
                    className="admin-tabs admin-sub-tabs"
                >
                    <Tab label="Validation des projets" />
                    <Tab label="Projets" />
                </Tabs>
            </Box>

            <div className="tab-content-wrapper">
                {activeSubTab === 0 && (
                    <div className="stats-grid">
                        <ProjectValidation />
                    </div>
                )}

                {activeSubTab === 1 && (
                    <div className="stats-grid">
                        <Projects />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectsTab;
